<template>
  <va-card v-if="!this.$store.getters.isLoading">
    <div class="va-card__header">
      <div class="va-card__header-title" @click="toEditContent(content.appContentId)" style="color: rgb(108, 127, 238);">{{ content.title }}
        <span v-if="content.isGlobal" :title="$t('content.global')"><i class="va-icon fa fa-globe"></i></span></div>
      <div class="va-card__header-actions">
        <KebabMenu>
          <div slot="buttons">
            <va-button-group>
              <va-button flat small color="gray" @click="toEditContent(content.appContentId)" :title="$t('kebabMenu.edit')" icon-right="fa fa-edit"> {{ $t('kebabMenu.edit') }}</va-button>
              <va-button flat small color="gray" @click="duplicateContent(content.appContentId)" :title="$t('kebabMenu.duplicate')" icon-right="fa fa-clone"> {{ $t('kebabMenu.duplicate') }}</va-button>
              <va-button flat small color="gray" @click="showPromptModal(content)" icon-right="fa fa-trash"> {{ $t('kebabMenu.remove') }}</va-button>
            </va-button-group>
          </div>
        </KebabMenu>
      </div>
    </div>
    <p v-if="!this.$store.getters.isLoading && !isLocationPage && content.eventIds && content.eventIds.length">{{ $t('content.locations') }}:
      <span class="location" v-for="(locationId, index) in content.eventIds" :key="index" @click="toLocation(locationId)">
        {{ locationNames(content)[index] }}
        {{ index !== content.eventIds.length - 1 ? ', ' : '' }}
      </span>
    </p>
    <div class="content-meta" v-for="(meta, index) in parseMeta" :key="index">
      <div v-html="meta.Value"></div>
    </div>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('content.deleteModal.title')"
      :message="$t('content.deleteModal.message')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('content.deleteModal.btnNo') }}</va-button>
        <va-button type="submit" @click="removeContent(contentInPrompt)" class="my-0">{{ $t('content.deleteModal.btnYes') }}</va-button>
      </div>
    </va-modal>
  </va-card>
</template>

<script>
import KebabMenu from '@/components/menus/KebabMenu.vue'
export default {
  name: 'ContentCard',
  data () {
    return {
      locations: [],
      showRemoveModal: false,
      contentInPrompt: null,
    }
  },
  components: { KebabMenu },
  props: {
    content: Object,
  },
  computed: {
    parseMeta () {
      return JSON.parse(this.content.meta)
    },
    isLocationPage () {
      const isLocationPage = this.$router.currentRoute.path.startsWith('/admin/location/')
      return isLocationPage
    },
  },
  methods: {
    async getTheLocations () {
      await this.$store.dispatch('getLocations')
        .then(() => {
          this.initLocations()
        })
        .catch(error => {
          this.errorHandler(error.response)
        })
    },
    async initLocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
    async toLocation (locationId) {
      await this.$router.push({
        name: 'location',
        params: { locationId: locationId },
      })
    },
    async toEditContent (appContentId) {
      await this.$router.push({
        name: 'update-content',
        params: { appContentId: appContentId },
      })
    },
    async duplicateContent (appContentId) {
      await this.$store.dispatch('duplicateContent', appContentId)
        .then((resp) => {
          this.$store.commit('add_content', resp.data.message)
          this.$emit('content-duplicated', resp.data.message)
        }).catch(error => {
          this.errorHandler(error.response)
        })
    },
    locationNames (content) {
      return content.eventIds.map(locationId => {
        const location = this.locations.find(loc => loc.eventId === locationId)
        return location ? location.name : ''
      })
    },
    async removeContent (content) {
      const appContentId = content.appContentId
      await this.$store.dispatch('deleteContent', appContentId)
        .then(() => {
          this.$store.commit('remove_content', appContentId)
          this.showRemoveModal = false
          this.$emit('content-deleted', appContentId)
        }).catch(error => {
          this.errorHandler(error.response)
          this.showRemoveModal = false
        })
    },
    showPromptModal (content) {
      this.contentInPrompt = content
      this.showRemoveModal = true
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.getTheLocations()
    this.$store.commit('setLoading', false)
  },
}
</script>

<style lang="scss" scoped>
  .va-card {
    &__header {
      display: flex;
      align-items: center;

      &-title {
        font-size: 1rem;
        display: flex;
        align-items: center;

        &:hover {
          cursor: pointer;
        }

        .va-icon {
          margin: 0 5px;
        }
      }

      &-actions {
        display: flex;
      }
    }

    &__body {
      overflow: visible;

      .va-button--small.va-button--with-right-icon {
        padding-right: 0.75rem;
      }

      p {
        font-size: 14px;
      }

      .location {
        color: rgb(113, 186, 255);

        &:hover {
          cursor: pointer;
        }
      }

      .message {
        display: flex;

        .inline-editor {
          margin-left: 5px;
          overflow: hidden;

          .value-display {
            white-space: inherit;
          }
        }
      }
    }

    .content-meta {
      margin-bottom: 25px;
    }
  }
</style>
